export const syncVueSelectA11y = ({
	root,
	labelId,
	statusId,
	hasSelectedValue = false,
	invalid = false,
	errorId = '',
	clearLabel = 'Очистити вибір',
} = {}) => {
	if (!root || !labelId) return;

	const select = root.querySelector('.v-select');
	if (!select) return;

	const labelledElements = [
		select.querySelector('[role="combobox"]'),
		select.querySelector('.vs__search'),
		select.querySelector('[role="listbox"]'),
	].filter(Boolean);

	labelledElements.forEach((element) => {
		element.removeAttribute('aria-label');
		element.setAttribute('aria-labelledby', labelId);

		if (statusId && hasSelectedValue) {
			element.setAttribute('aria-describedby', statusId);
		} else {
			element.removeAttribute('aria-describedby');
		}
	});

	const invalidElements = [
		select.querySelector('[role="combobox"]'),
		select.querySelector('.vs__search'),
	].filter(Boolean);

	invalidElements.forEach((element) => {
		if (invalid && errorId) {
			element.setAttribute('aria-invalid', 'true');
			element.setAttribute('aria-errormessage', errorId);
		} else {
			element.removeAttribute('aria-invalid');
			element.removeAttribute('aria-errormessage');
		}
	});

	select.querySelectorAll('.vs__clear, .vs__deselect').forEach((button) => {
		button.setAttribute('aria-label', clearLabel);
		button.setAttribute('title', clearLabel);
	});
};
